import { open } from 'fs/promises';
import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { uploadAvatar } from '../../../commands/user/uploadAvatar';
import useSession from '../../SessionHook/SessionHook'
import CropModal from "./CropModal";

export function AvatarDropzone(props: any) {

  const { hasSession, updateToken, getTBUid, token, clear } = useSession();

  const [openCropImgModal, setOpenCropImgModal] = useState(false);
  const [cropImgUrl, setCropImgUrl] = useState<any>();

  const onDrop = useCallback(async (acceptedFiles: any) => {
    // Do something with the files

    let url = window.URL.createObjectURL(acceptedFiles[0]);

    setCropImgUrl(url);
    setOpenCropImgModal(true);

    /*let tbuid = getTBUid();

    if (token && tbuid) {
      await uploadAvatar(token as string, tbuid, acceptedFiles[0]);
      props.afterUpload();
    }
    */
  }, [])

  //
  async function uploadImg(file: File) {
    let tbuid = getTBUid();

    if (token && tbuid) {
      await uploadAvatar(token as string, tbuid, file);
      props.afterUpload();
    }
  }

  //
  function closeCropModal() {
    setOpenCropImgModal(false);
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div {...getRootProps()} style={{ fontSize: "14px", cursor: "pointer", fontWeight: 700, background: '#29a151dd', borderRadius: "5px", width: "170px", color: "#fefefe", lineHeight: 1.2, padding: "2px 5px 2px 5px", textAlign: "center" }}>
      <input {...getInputProps()} />
      {
        isDragActive ?
          <p>Drop the files here ...</p> :
          <p>Drag and drop some files here, or click to select files</p>
      }

      {openCropImgModal &&
        <CropModal
          src={cropImgUrl}
          open={openCropImgModal}
          onClose={closeCropModal}
          afterCropDone={uploadImg}
        />}
    </div>
  )
}